<template>
  <div class="banner-wrapper">
    <!-- <el-menu
      :default-active="activeIndex2"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      background-color="#2FAEFF"
      text-color="#fff"
      active-text-color="#fff"
    >
      <el-menu-item index="1">网上报名</el-menu-item>
      <el-menu-item index="2">资格审查</el-menu-item>
      <el-menu-item index="3">在线缴费</el-menu-item>
      <el-menu-item index="4">准考证打印</el-menu-item>
      <el-menu-item index="5">成绩查询</el-menu-item>
    </el-menu> -->
    <div class="logo" @click="router.replace('/')" style="cursor: pointer;">
      <img class="logo-img" :src="logoImg" />方阵考务
    </div>
    <div class="user">
      <template v-if="storage.get('USER_INFO')?.value?.userName">
        <el-dropdown>
          <span class="el-dropdown-link">
            <el-link type="primary">欢迎您,{{ storage.get("USER_INFO")?.value?.userName }}</el-link>
            <el-icon class="el-icon--right">
              <arrow-down />
            </el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>
                <el-link :href="`./#/user/review`" :underline="false" target="_blank">个人中心</el-link>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-link :href="`./#/user/update`" :underline="false">修改密码</el-link>
              </el-dropdown-item>
              <!-- <el-dropdown-item :href="`./#/user/update`">修改密码</el-dropdown-item> -->
              <el-dropdown-item @click="exit">退出</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </template>
      <template v-else>
        <el-icon>
          <User />
        </el-icon>
        <el-link type="primary" @click="router.push('/login')">登录</el-link>
        <el-icon>
          <UserFilled />
        </el-icon>
        <el-link type="primary" @click="router.push('/regist')">注册</el-link>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import logoImg from "@/assets/logo.png";
import { useRoute, useRouter } from "vue-router";
import { useUserStore } from "@/store";
import { Storage } from "@/utils/storage/index";

const userStore = useUserStore();

const route = useRoute();
const router = useRouter();
const storage = Storage.getInstance();

const activeIndex = ref("1");
const activeIndex2 = ref("1");
const handleSelect = (key, keyPath) => {
  // console.log(key, keyPath);
};
const exit = () => {
  storage.remove("USER_INFO");
  window.location.replace(`${window.location.origin}` + window.proxy_path + `/#/login`);
};
</script>
<style lang="scss">
.banner-wrapper {
  background: #2faeff;
  @include flex-center();
  justify-content: space-between;
  align-items: center;

  .el-menu-demo {
    width: 100%;
  }

  .logo {
    height: 50px;
    line-height: 50px;
    margin-left: 20px;
    color: #fff;
    @include flex-center();

    .logo-img {
      width: 40px;
    }
  }

  .user {
    padding-right: 24px;
    width: 150px;
    @include flex-center();
    justify-content: space-between;
    align-items: center;

    .el-icon,
    .el-link {
      font-weight: bold;
      color: #fff;
    }

    .el-icon {
      font-size: 20px;
    }

    .el-dropdown {
      .el-dropdown-link {
        @include flex-center();
        outline: none;
      }
    }
  }
}
</style>
